import React, { useState } from 'react';
import { Box, Flex, Heading, Input, Textarea, Button, Text, FormControl, FormLabel, useToast, SimpleGrid, Link } from '@chakra-ui/react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('send_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast({
          title: 'Mensagem enviada com sucesso.',
          status: 'success',
          duration: 3000,
          isClosable: true
        });
        setFormData({ nome: '', email: '', telefone: '', mensagem: '' });
      } else {
        toast({
          title: 'Erro ao enviar mensagem.',
          status: 'error',
          duration: 3000,
          isClosable: true
        });
      }
    } catch (error) {
      toast({
        title: 'Erro ao enviar mensagem.',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    }
  };

  return (
    <Box minH="calc(100vh - 80px)" bg="white" display="flex" justifyContent="center" p={8}>
      <Box w={{ base: "100%", lg: "70%" }}>
        <Flex direction={{ base: 'column', md: 'row' }} spacing={10} justifyContent="space-between">
          {/* Formulário */}
          <Box flex="1" p={5} boxShadow="md" bg="white" borderRadius="0" mx={{ base: 2, md: 6 }} mb={{ base: 6, md: 0 }}>
            <Heading as="h3" size="md" mb={2} color="gold.500" textAlign="center">
              Entre em Contato
            </Heading>
            <Text fontSize="lg" mb={4} color="black" textAlign="center">
              Estamos aqui para te auxiliar!
            </Text>
            <form onSubmit={handleSubmit}>
              {[
                { name: 'nome', placeholder: 'Digite seu nome' },
                { name: 'email', placeholder: 'Digite seu e-mail' },
                { name: 'telefone', placeholder: 'Digite seu telefone' },
                { name: 'mensagem', placeholder: 'Digite sua mensagem' }
              ].map((field, index) => (
                <FormControl id={field.name} isRequired mb={4} key={index}>
                  <FormLabel color="black">
                    {field.name.toUpperCase(0)}
                  </FormLabel>
                  {field.name === 'mensagem' ? (
                    <Textarea
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                      borderColor="black"
                      _focus={{ borderColor: "black", boxShadow: "0 0 5px black" }}
                      rows={6}
                      placeholder={field.placeholder}
                      borderRadius="0"
                    />
                  ) : (
                    <Input
                      name={field.name}
                      type={field.name === 'email' ? 'email' : 'text'}
                      value={formData[field.name]}
                      onChange={handleChange}
                      borderColor="black"
                      _focus={{ borderColor: "black", boxShadow: "0 0 5px black" }}
                      placeholder={field.placeholder}
                      borderRadius="0"
                    />
                  )}
                </FormControl>
              ))}
              <Button
                type="submit"
                bg="gold.500"
                color="black"
                width="100%"
                _hover={{ bg: "gold.700" }}
              >
                Enviar
              </Button>
            </form>
          </Box>
          {/* Horários Comerciais */}
          <Box flex="1" p={5} boxShadow="md" bg="gray.50" borderRadius="0" mx={{ base: 2, md: 6 }} height={{ base: "auto", md: "auto" }}>
            <Heading as="h3" size="lg" mb={2} color="gold.500" textAlign="center">
              Horários Comerciais
            </Heading>
            <Text fontSize="xl" mb={6} color="black" textAlign="center">
              Estamos aqui para te auxiliar!
            </Text>
            <Box w={{base: "100%", md: "70%", lg: "70%"}} marginX="auto">
              <Text fontSize="lg" align={{ base: 'center', md: 'center' }} mb={8}>
                <Link href="mailto:comercial@cdempilhadeiras.com" color="gold.500" _hover={{ textDecoration: "underline" }}>
                  cdempilhadeiras
                </Link>
              </Text>
              <SimpleGrid columns={2} spacing={2}>
                <Text textAlign="left" fontSize="md"><strong>Segunda-feira:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 18:00</Text>
                <Text textAlign="left" fontSize="md"><strong>Terça-feira:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 18:00</Text>
                <Text textAlign="left" fontSize="md"><strong>Quarta-feira:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 18:00</Text>
                <Text textAlign="left" fontSize="md"><strong>Quinta-feira:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 18:00</Text>
                <Text textAlign="left" fontSize="md"><strong>Sexta-feira:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 18:00</Text>
                <Text textAlign="left" fontSize="md"><strong>Sábado:</strong></Text>
                <Text textAlign="right" fontSize="md">8:00 – 13:00</Text>
              </SimpleGrid>
            </Box>
            <Text mt={16} fontSize={{ base: 'sm', md: 'lg' }} fontWeight="bold" textAlign={{ base: 'center', md: 'center' }} color={'gold.500'}>
              Nosso Endereço:
            </Text>
            <Text mt={6} fontSize={{ base: 'sm', md: 'lg' }} fontWeight="bold" textAlign={{ base: 'center', md: 'center' }}>
              Avenida Leão Dourado, 2403 - Galpão 03 - Kenedy <br /> CEP: 55036-000 - Caruaru/PE 
            </Text>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default ContactSection;
